import { useMemo } from 'react'
import { useAppSelector } from '../../../utils/agent.store'
import { SITE_SETTINGS_KEYS } from '../../../utils/constants'

export const useCloseDedupeCaseEnabled = (embedded = false) => {
  const siteSettings = useAppSelector((state) => state.authUser?.site_settings)

  const isCloseDeduplicateCaseEnabled = useMemo(
    () =>
      siteSettings?.some(
        (item) =>
          item?.key === SITE_SETTINGS_KEYS.CLOSE_DEDUPLICATE_CASE &&
          String(item?.value ?? '').toLowerCase() === 'true'
      ) ?? false,
    [siteSettings]
  )

  const shouldShowCloseDedupeFlow = !embedded && isCloseDeduplicateCaseEnabled

  return {
    isCloseDeduplicateCaseEnabled,
    shouldShowCloseDedupeFlow,
  }
}
